import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import Layout from './components/Layout'
import { Spinner } from './components/common'
import { AuthProvider, useAuth } from './auth/AuthContext'
import AssetDetail from './pages/AssetDetail'
import Assets from './pages/Assets'
import CIDetail from './pages/CIDetail'
import ConfigurationItems from './pages/ConfigurationItems'
import ConnectorDetail from './pages/ConnectorDetail'
import Connectors from './pages/Connectors'
import ContractDetail from './pages/ContractDetail'
import Contracts from './pages/Contracts'
import Fornitori from './pages/Fornitori'
import FornitoreDettaglio from './pages/FornitoreDettaglio'
import Credentials from './pages/Credentials'
import Dashboard from './pages/Dashboard'
import Dobermann from './pages/Dobermann'
import Honeypot from './pages/Honeypot'
import Audit from './pages/Audit'
import ScanStats from './pages/ScanStats'
import Guida from './pages/Guida'
import Nis2 from './pages/Nis2'
import Dora from './pages/Dora'
import Cra from './pages/Cra'
import CraProdotto from './pages/CraProdotto'
import CraSegnalazione from './pages/CraSegnalazione'
import Fleet from './pages/Fleet'
import ProbeGroups from './pages/ProbeGroups'
import Flows from './pages/Flows'
import FlowEntryPoints from './pages/FlowEntryPoints'
import FlowExporters from './pages/FlowExporters'
import FlowAnalysis from './pages/FlowAnalysis'
import DiscoveryPlanEditor from './pages/DiscoveryPlanEditor'
import DiscoveryPlans from './pages/DiscoveryPlans'
import DeviceConfigs from './pages/DeviceConfigs'
import Pools from './pages/Pools'
import Users from './pages/Users'
import ChiaviApi from './pages/ChiaviApi'
import InventoryAgents from './pages/InventoryAgents'
import Jobs from './pages/Jobs'
import Login from './pages/Login'
import ProbeDetail from './pages/ProbeDetail'
import Reports from './pages/Reports'
import FlowMap from './pages/FlowMap'
import Usage from './pages/Usage'
import Schedules from './pages/Schedules'
import ServiceDetail from './pages/ServiceDetail'
import Services from './pages/Services'
import Settings from './pages/Settings'
import Taxonomy from './pages/Taxonomy'
import NetworkDevices from './pages/NetworkDevices'
import Firmware from './pages/Firmware'
import Topology from './pages/Topology'
import VirtualMap from './pages/VirtualMap'
import CapacityPlan from './pages/CapacityPlan'
import { t } from './i18n/lingua'
import SecurityHealth from './pages/SecurityHealth'
import AiUsage from './pages/AiUsage'
import Wazuh from './pages/Wazuh'
import Cynet from './pages/Cynet'
import Firewall from './pages/Firewall'
import RouteAnalyzer from './pages/RouteAnalyzer'
import Presenza from './pages/Presenza'
import VInventory from './pages/VInventory'
import CInventory from './pages/CInventory'
import CloudMap from './pages/CloudMap'
import Eagle from './pages/Eagle'
import MedArea from './pages/MedArea'
import MedDevice from './pages/MedDevice'
import AccessArea from './pages/AccessArea'
import AccessPersonPage from './pages/AccessPerson'
import Sinottico from './pages/Sinottico'
import MasterData from './pages/MasterData'
import EagleSinottico from './pages/EagleSinottico'
import MonitorAttesa from './pages/MonitorAttesa'
import { tokenChiosco } from './api/client'
import CostCenter from './pages/CostCenter'
import SoftwareMap from './pages/SoftwareMap'
import SoftwareFlow from './pages/SoftwareFlow'
import Cifratura from './pages/Cifratura'
import GestioneCertificati from './pages/GestioneCertificati'
import BitLocker from './pages/BitLocker'
import AddressInventory from './pages/AddressInventory'
import Patching from './pages/Patching'
import BusinessApps from './pages/BusinessApps'
import BusinessAppDetail from './pages/BusinessAppDetail'
import ContainerInventory from './pages/ContainerInventory'
import SoftwareList from './pages/SoftwareList'
import SoftwareEol from './pages/SoftwareEol'
import SoftwareLicenses from './pages/SoftwareLicenses'
import SoftwareProdotto from './pages/SoftwareProdotto'
import ProgettoCodice from './pages/ProgettoCodice'
import Tags from './pages/Tags'
import Dns from './pages/Dns'
import Backup from './pages/Backup'
import BackupJob from './pages/BackupJob'
import Ipam from './pages/Ipam'
import Awx from './pages/Awx'
import { LicenzaScaduta } from './components/LicenzaScaduta'
import Integrazioni from './pages/Integrazioni'
import SetPassword from './pages/SetPassword'

/** Mostra la console solo a sessione valida, altrimenti la pagina di accesso. */
function Routed() {
  const { principal, loading, verificaLenta } = useAuth()

  // Prima di ogni controllo di sessione: chi arriva dall'invito non ha
  // credenziali, e la pagina deve aprirsi comunque.
  if (window.location.pathname === '/set-password') return <SetPassword />
  // A wall monitor opened through its link (`/monitor/eagle/<token>`): the
  // Eagle wall with no session and no console, like the invitation page.
  if (tokenChiosco()) return <EagleSinottico chiosco />
  // A screen waiting to be paired (CENSO Monitor): the code, no session.
  if (window.location.pathname === '/monitor/attesa') return <MonitorAttesa />

  if (loading)
    return (
      <Spinner
        label={
          verificaLenta
            ? t('Sta impiegando più del solito: il Control Plane potrebbe essere in riavvio. Riprovo da solo…')
            : t('Verifica sessione…')
        }
      />
    )
  if (!principal) return <Login />

  return (
    <LicenzaScaduta>
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="dobermann" element={<Dobermann />} />
        <Route path="honeypot" element={<Honeypot />} />
        <Route path="guide" element={<Guida />} />
        <Route path="nis2" element={<Nis2 />} />
        <Route path="dora" element={<Dora />} />
        <Route path="cra" element={<Cra />} />
        <Route path="cra/products/:id" element={<CraProdotto />} />
        <Route path="cra/reports/:id" element={<CraSegnalazione />} />
        <Route path="cis" element={<ConfigurationItems />} />
        <Route path="cis/:id" element={<CIDetail />} />
        <Route path="assets" element={<Assets />} />
        <Route path="assets/:id" element={<AssetDetail />} />
        <Route path="contracts" element={<Contracts />} />
        <Route path="suppliers" element={<Fornitori vista="panoramica" />} />
        <Route path="suppliers/list" element={<Fornitori vista="elenco" />} />
        <Route path="suppliers/catalog" element={<Fornitori vista="catalogo" />} />
        <Route path="suppliers/ict" element={<Fornitori vista="ict" />} />
        <Route path="suppliers/requests" element={<Fornitori vista="richieste" />} />
        <Route path="suppliers/:id" element={<FornitoreDettaglio />} />
        <Route path="contracts/:id" element={<ContractDetail />} />
        <Route path="reports" element={<Reports />} />
        <Route path="usage" element={<Usage />} />
        <Route path="scan-stats" element={<ScanStats />} />
        <Route path="network" element={<NetworkDevices />} />
        <Route path="firmware" element={<Firmware />} />
        <Route path="topology" element={<Topology />} />
        <Route path="virtual-map" element={<VirtualMap />} />
        <Route path="vinventory" element={<VInventory />} />
        <Route path="cloud-map" element={<CloudMap />} />
        <Route path="sinottico" element={<Sinottico />} />
        <Route path="master-data" element={<MasterData />} />
        <Route path="eagle/sinottico" element={<EagleSinottico />} />
        <Route path="eagle" element={<Eagle />} />
        <Route path="eagle/cis" element={<Eagle />} />
        <Route path="eagle/sonde" element={<Eagle />} />
        <Route path="eagle/notifiche" element={<Eagle />} />
        <Route path="eagle/report" element={<Eagle />} />
        <Route path="eagle/profili" element={<Eagle />} />
        <Route path="eagle/parete" element={<Eagle />} />
        <Route path="eagle/cruscotti" element={<Eagle />} />
        <Route path="medical" element={<MedArea />} />
        <Route path="medical/:vista" element={<MedArea />} />
        <Route path="medical/devices/:id" element={<MedDevice />} />
        <Route path="access" element={<AccessArea />} />
        <Route path="access/:vista" element={<AccessArea />} />
        <Route path="access/people/:id" element={<AccessPersonPage />} />
        <Route path="cinventory" element={<CInventory />} />
        <Route path="cost-center" element={<CostCenter />} />
        <Route path="software-flow" element={<SoftwareFlow />} />
        <Route path="encryption" element={<Cifratura />} />
        <Route path="encryption/certificates" element={<Cifratura predefinita="anagrafica" />} />
        <Route path="certificates" element={<GestioneCertificati />} />
        <Route path="bitlocker" element={<BitLocker />} />
        <Route path="addresses" element={<AddressInventory />} />
        <Route path="patching" element={<Patching />} />
        <Route path="plaintext-traffic" element={<Navigate to="/encryption?tab=chiaro" replace />} />
        <Route path="software-map" element={<SoftwareMap />} />
        <Route path="container-inventory" element={<ContainerInventory />} />
        <Route path="software-list" element={<SoftwareList />} />
        <Route path="software-eol" element={<SoftwareEol />} />
        <Route path="software-licenses" element={<SoftwareLicenses />} />
        <Route path="software-supply" element={<SoftwareProdotto />} />
        <Route path="software-supply/:vista" element={<SoftwareProdotto />} />
        <Route path="software-supply/projects/:id" element={<ProgettoCodice />} />
        <Route path="tags" element={<Tags />} />
        <Route path="dns" element={<Dns />} />
        <Route path="backup" element={<Backup />} />
        <Route path="backup/jobs/:vendor/:id" element={<BackupJob />} />
        <Route path="ipam" element={<Ipam />} />
        <Route path="awx" element={<Awx />} />
        <Route path="capacity" element={<CapacityPlan />} />
        {/* Il traffico è una sezione, non una pagina: tre viste sugli stessi dati,
            con la finestra temporale condivisa attraverso la query string. */}
        <Route path="flows" element={<Flows />} />
        <Route path="presence" element={<Presenza />} />
        <Route path="flows/entry-points" element={<FlowEntryPoints />} />
        <Route path="flows/exporters" element={<FlowExporters />} />
        <Route path="flows/analysis" element={<FlowAnalysis />} />
        <Route path="flows/map" element={<FlowMap />} />
        <Route path="routing" element={<RouteAnalyzer />} />
        <Route path="security-health" element={<SecurityHealth />} />
        <Route path="ai-usage" element={<AiUsage />} />
        <Route path="wazuh" element={<Wazuh />} />
        <Route path="cynet" element={<Cynet />} />
        <Route path="firewall" element={<Firewall />} />
        <Route path="services" element={<Services />} />
        <Route path="services/:id" element={<ServiceDetail />} />
        <Route path="business-apps" element={<BusinessApps />} />
        <Route path="business-apps/:id" element={<BusinessAppDetail />} />
        <Route path="fleet" element={<Fleet />} />
        <Route path="probe-groups" element={<ProbeGroups />} />
        <Route path="fleet/:id" element={<ProbeDetail />} />
        <Route path="users" element={<Users />} />
        <Route path="api-keys" element={<ChiaviApi />} />
        <Route path="pools" element={<Pools />} />
        <Route path="device-configs" element={<DeviceConfigs />} />
        <Route path="inventory-agents" element={<InventoryAgents />} />
        <Route path="discovery-plans" element={<DiscoveryPlans />} />
        <Route path="discovery-plans/:id" element={<DiscoveryPlanEditor />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="schedules" element={<Schedules />} />
        <Route path="credentials" element={<Credentials />} />
        <Route path="integrations" element={<Integrazioni />} />
        <Route path="connectors" element={<Connectors />} />
        <Route path="connectors/:id" element={<ConnectorDetail />} />
        <Route path="settings" element={<Settings />} />
        <Route path="audit" element={<Audit />} />
        <Route path="taxonomy" element={<Taxonomy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </LicenzaScaduta>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routed />
      </AuthProvider>
    </BrowserRouter>
  )
}
